import { http } from "./http";
import type { MasspayConnectAnswer, MasspayStatusAnswer, MasspayWalletLinkAnswer } from "../types/payout";

// MassPay: payouts for talent in countries Stripe cannot pay (Indonesia
// first). The server creates the payee and hands back MassPay's ID-check
// (Veriff) link; the legal name goes to MassPay and is not stored by us.
export const masspayApi = {
  connect: (body: { legalFirstName: string; legalLastName: string; countryCode?: string }) =>
    http.post<MasspayConnectAnswer>("/masspay/connect", body),
  status: () => http.get<MasspayStatusAnswer>("/masspay/status"),
  /** The talent's own wallet link: MassPay's activation page until they've set a password, else the login. */
  walletLink: (timeoutMs: number) => http.get<MasspayWalletLinkAnswer>("/masspay/wallet-link", { timeout: timeoutMs }),
};
